module.exports = __webpack_public_path__ + "img/Jump Casting68.6be2ca85.jpg";